export default { sha: '15ddf4c3da788c619e8a55353baee91bdf6dcc7f', buildNumber: 'undefined' }
